/**
 * Optional.tsx
 * @author Diao Zheng
 * @file renders to some content iff predicate is truthy
 * @barrel component
 */
import React from "react";
export function Optional(props) {
    if (props.predicate) {
        return props.children;
    }
    return React.createElement(React.Fragment, null);
}
